import React, { useMemo } from 'react'
import dayjs from 'dayjs'
import { USER_TYPE } from '../../../../../../../../constants'

export const useColumns = ({
  formatter,
  classes
}) => {
  return useMemo(() => ([
    {
      accessor: 'externalUserId',
      disableSortBy: true,
      Header: (params) => {
        return (
          <div style={{ width: '30px' }}>
            <input
              type='checkbox'
              {...params.getToggleAllRowsSelectedProps()}
            />
          </div>
        )
      },
      Cell: (params) => {
        return (
          <div style={{ width: '30px' }}>
            <input
              type='checkbox'
              {...params.row.getToggleRowSelectedProps()}
            />
          </div>
        )
      }
    },
    {
      accessor: 'firstName',
      Header: 'First Name'
    },
    {
      accessor: 'lastName',
      Header: 'last Name'
    },
    {
      accessor: 'email',
      Header: 'Email'
    },
    {
      accessor: 'userTypeId',
      Header: 'User Type',
      Cell: (params) => {
        const userType = Number(params.value) === USER_TYPE.WEALTH_OWNER ? 'Wealth Owner' : 'Advisor'
        return <span>{userType}</span>
      }
    },
    {
      accessor: 'oktaData',
      Header: 'Created Date',
      Cell: (params) => {
        return formatter(params.value.created, '@M/D/YY h:mm A')
      }
    },
    {
      accessor: 'invitations',
      Header: 'Invitations',
      Cell: (params) => {
        if (!params.value?.length) {
          return <em>No Previous Invitations</em>
        }
        const invitations = params.value.map((inv, idx) => ({
          ...inv,
          accepted: !!inv.acceptedDate,
          expired: !inv.acceptedDate && dayjs().isAfter(inv.expirationDate),
          outstanding: idx === 0 && !inv.acceptedDate && dayjs().isBefore(inv.expirationDate)
        }))

        return (
          <>
            <table className={classes.invitationTable}>
              <thead>
                <tr>
                  <th>Invited On</th>
                  <th>Accepted On</th>
                  <th>Status</th>
                  <th>Invited By</th>
                </tr>
              </thead>
              <tbody>
                {invitations.map(ui => (
                  <tr key={ui.invitationId}>
                    <td>{formatter(ui.createdDate, '@M/D/YY h:mm A')}</td>
                    <td>{formatter(ui.acceptedDate, '@M/D/YY h:mm A')}</td>
                    <td>{ui.outstanding ? (
                    `Expires ${formatter(ui.expirationDate, 'ß')}`
                    ) : (
                      ui.accepted
                        ? 'Accepted'
                        : ui.expired
                          ? 'Expired'
                          : 'Invalid'
                    )}
                    </td>
                    <td>{ui.createdByUserName}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        )
      }
    }
  ]), [formatter, classes])
}
